import { ErrorInfo } from 'react';
import * as Sentry from '@sentry/browser';
import { logglyLogger } from '../../services/logglyLogger';

export const reportBoundaryError = (error: Error, errorInfo: ErrorInfo): void => {
  logglyLogger.log({ error: error.name, info: errorInfo.componentStack ?? undefined });
  console.error('Uncaught render error triggered Error Boundary', error, errorInfo);
  Sentry.captureException(error);
};
